<script>
import ProfileIdentityCard from '@/components/profile/ProfileIdentityCard.vue'
import ProfileCompletionCard from '@/components/profile/ProfileCompletionCard.vue'
import ProfileLevelCard from '@/components/profile/ProfileLevelCard.vue'
import ProfilePointsCard from '@/components/profile/ProfilePointsCard.vue'

export default {
	name: 'ProfileHeaderInfo',
	components: {
		ProfileIdentityCard,
		ProfileCompletionCard,
		ProfileLevelCard,
		ProfilePointsCard
	},
	props: {
		avatarUrl: {
			type: String,
			default: null
		},
		fullName: {
			type: String,
			default: ''
		},
		memberCode: {
			type: [String, Number],
			default: ''
		},
		completion: {
			type: Number,
			default: 0
		},
		level: {
			type: Number,
			default: 1
		},
		levelName: {
			type: String,
			default: ''
		},
		levelRange: {
			type: String,
			default: ''
		},
		points: {
			type: Number,
			default: 0
		},
		pointsTarget: {
			type: Number,
			default: 0
		},
		photoEnabled: {
			type: Boolean,
			default: false
		}
	},
	emits: ['change-photo'],
	computed: {
		profileLevelPointsEnabled() {
			return __PROFILE_LEVEL_POINTS_ENABLED__
		}
	}
}
</script>

<template>
	<section
		class="profile-header-info"
		:class="{ 'profile-header-info--without-level-points': !profileLevelPointsEnabled }"
		data-qa="profile-summary-section"
		:aria-label="$t('myArea.headerInfo.ariaLabel')"
	>
		<ProfileIdentityCard
			class="profile-header-info__identity"
			:avatar-url="avatarUrl"
			:full-name="fullName"
			:member-code="memberCode"
			:photo-enabled="photoEnabled"
			@change-photo="$emit('change-photo')"
		/>

		<!-- Oculto aguardando entrar sistema de pontos ======= -->
		<ProfilePointsCard v-if="profileLevelPointsEnabled" class="profile-header-info__points" :points="points" :target="pointsTarget" v-show="false" />
		
		<ProfileCompletionCard class="profile-header-info__completion" :completion="completion"  />
		<ProfileLevelCard v-if="profileLevelPointsEnabled" class="profile-header-info__level" :level="level" :name="levelName" :range="levelRange" v-show="false"/>

		<!-- Oculto aguardando entrar sistema de pontos ======= -->
	</section>
</template>

<style lang="sass" scoped>
@use '../../assets/sass/utilities/_responsive' as *

.profile-header-info
	display: grid
	grid-template-columns: repeat(2, minmax(0, 1fr))
	grid-template-areas: 'identity identity' 'points points' 'completion level'
	align-items: stretch
	gap: 1rem
	width: 100%
	margin-inline: auto

	:deep(.profile-info-card)
		height: 100%
		min-height: 0
		padding: 0.75rem 1.5rem
		border-radius: 1rem
		background-color: var(--white)
		box-shadow: var(--shadow-default)

	:deep(.profile-completion-card), :deep(.profile-level-card)
		flex-direction: column
		align-items: flex-start

	:deep(.profile-level-card__eyebrow)
		line-height: 0.75

	:deep(.profile-level-card h2)
		line-height: 0.7

	:deep(.profile-level-card__range)
		line-height: 0.6667

	:deep(.profile-points-card__progress)
		margin-top: 0.5rem

	:deep(.profile-points-card__hint)
		margin-top: 0.5rem

	+respond-to($breakpoint-lg-min)
		grid-template-columns: repeat(2, minmax(0, 1fr))

		:deep(.profile-info-card)
			min-height: 6rem

		:deep(.profile-completion-card), :deep(.profile-level-card)
			flex-direction: row
			align-items: center

		:deep(.profile-level-card__eyebrow), :deep(.profile-level-card h2), :deep(.profile-level-card__range)
			line-height: 1

		:deep(.profile-points-card__progress)
			margin-top: 0.625rem

		:deep(.profile-points-card__hint)
			margin-top: 0.75rem

	+respond-to($breakpoint-xs-min)
		grid-template-columns: minmax(18rem, 1.35fr) minmax(13rem, 0.9fr) minmax(13rem, 0.95fr) minmax(20rem, 1.65fr)
		grid-template-areas: 'identity completion level points'

	&__identity
		grid-area: identity

	&__completion
		grid-area: completion

	&__level
		grid-area: level

	&__points
		grid-area: points

	&__identity, &__completion, &__level, &__points
		min-width: 0

	&--without-level-points
		grid-template-columns: minmax(0, 1fr)
		grid-template-areas: 'identity' 'completion'

		+respond-to($breakpoint-lg-min)
			grid-template-columns: minmax(24rem, 1.9fr) minmax(13rem, 1fr)
			grid-template-areas: 'identity completion'
</style>
